import { ReactElement } from 'react'
import { Box } from '@mui/material'
import VisibilitySwitches from '@editor/components/Controls/VisibilityFilters'
import { PopoverPanel } from '@ui2/structure'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
}

/**
 * "Weiteres" filter popover for the storey controls (opened from the Sonstiges column button). Houses
 * the leftover structural-planning visibility switches (wind loads, supports, component labels),
 * mirroring the IFC column's "Sonstiges" filter popover.
 */
const WeiteresFilterPopover = ({ anchorEl, onClose }: Props): ReactElement => (
  <PopoverPanel
    anchorEl={anchorEl}
    onClose={onClose}
    title="Weiteres"
    dataCy="model-weiteres-popover"
  >
    <Box sx={{ width: 420 }}>
      <VisibilitySwitches />
    </Box>
  </PopoverPanel>
)

export default WeiteresFilterPopover
